import React from 'react'
import arrowRight from "../../../assets/arrow-right.svg"

type NextButtonType = {
    filled: boolean,
    submit: boolean,
    onNext: () => void,
    onSubmit: () => void,
}

function NextButton(props: NextButtonType) {
    return (
        <button
            onClick={() => {
                if (!props.filled) return;
                props.onNext();
                if (props.submit) props.onSubmit();
            }}
            disabled={!props.filled}
            className={`items-center flex py-3 px-8 rounded-3xl justify-center w-full sm:w-fit gap-4 transition-all ease-in duration-300 group border 
                        ${!props.filled
                    ? "cursor-not-allowed bg-primary/20 border-primary/0"
                    : "bg-primary border-transparent hover:bg-base-100 hover:border hover:border-secondary border-primary"}`}
        >
            <div>
                {props.submit ? "Absenden" : "Weiter"}
            </div>
            <img
                src={arrowRight}
                alt="Pfeil Rechts"
                className={`transition-all ease-in duration-200 ${props.filled ? "group-hover:translate-x-1" : ""}`}
            />
        </button>
    )
}

export default NextButton